import { Suspense, lazy } from 'react';
import type { SlotEntry, SlotProps } from '@saas/ui';
import { MEETING_READ } from './nav.js';

/**
 * 画面の差し込み口（`@saas/ui` の `Slot`）に meeting-ingest が出すもの。登録は apps/web（リード）が行う。
 *
 *  - `record.panel`（顧客 / 商談 / 案件） … そのレコードの最近の会議（要約の 1 行・決定事項の数・未完の宿題）
 *  - `dashboard.inbox`（自分宛て）        … 期限が 3 日以内 か 過ぎた自分の宿題
 *
 * 部品は `lazy` + `Suspense`（初期バンドルを太らせない）。中身が空なら null を返して場所を取らない。
 * API の 403 / 404 は「空」として扱う（モジュールが無効・権限が無いテナントでも画面を壊さない）
 */
const RecordMeetingsPanel = lazy(() => import('./components/RecordMeetingsPanel.js'));
const MyActionItemsPanel = lazy(() => import('./components/MyActionItemsPanel.js'));
const CalendarMeetingPanel = lazy(() => import('./components/CalendarMeetingPanel.js'));

export const meetingIngestSlots: SlotEntry[] = [
  {
    id: 'meeting-ingest.calendar-meeting',
    module: 'meeting-ingest',
    slot: 'record.panel',
    subjectTypes: ['calendar_event'],
    permission: MEETING_READ,
    order: 10,
    Component: (props: SlotProps) => (
      <Suspense fallback={null}>
        <CalendarMeetingPanel {...props} />
      </Suspense>
    ),
  },
  {
    id: 'meeting-ingest.record-meetings',
    module: 'meeting-ingest',
    slot: 'record.panel',
    subjectTypes: ['customer', 'deal', 'project'],
    permission: MEETING_READ,
    order: 40,
    Component: (props: SlotProps) => (
      <Suspense fallback={null}>
        <RecordMeetingsPanel {...props} />
      </Suspense>
    ),
  },
  {
    id: 'meeting-ingest.my-action-items',
    module: 'meeting-ingest',
    slot: 'dashboard.inbox',
    subjectTypes: ['user'],
    permission: MEETING_READ,
    order: 30,
    Component: () => (
      <Suspense fallback={null}>
        <MyActionItemsPanel />
      </Suspense>
    ),
  },
];
